/** Support ticketing access level granted to a contact. */
export const SUPPORT_TICKET_ACCESS_LEVELS = ['no_access', 'ticket_user', 'ticket_manager'];
export const SUPPORT_TICKET_ACCESS_LABELS = {
    no_access: 'No Access',
    ticket_user: 'Ticket User',
    ticket_manager: 'Ticket Manager',
};
/** AI feature access level granted to a contact. */
export const AI_ACCESS_LEVELS = ['no_access', 'ai_user', 'ai_manager'];
export const AI_ACCESS_LABELS = {
    no_access: 'No Access',
    ai_user: 'AI User',
    ai_manager: 'AI Manager',
};
/** Administrative access level granted to a contact. */
export const ADMIN_ACCESS_LEVELS = ['no_access', 'billing_admin'];
export const ADMIN_ACCESS_LABELS = {
    no_access: 'No Access',
    billing_admin: 'Billing Admin',
};
//# sourceMappingURL=contact.js.map